import { Component, OnInit, Input } from '@angular/core';

import { SharedLatestNewsService } from './shared-latest-news.service';

@Component({
    selector: 'app-shared-latest-news',
    templateUrl: './shared-latest-news.component.html',
    styleUrls: ['./shared-latest-news.component.scss'],
})
export class SharedLatestNewsComponent implements OnInit {
    @Input() departmentId: any;
    @Input() departmentType: any;

    /* Paginação */
    perPage: number = 10;
    page: number = 1;
    total: 0;

    /**
     * RETORNO API
     * errors: Coleção de erros com falhas vindo do servidor
     * message: Mensagem de falha/sucesso processada pela API
     * statusCode: Código da mensagem de falha/sucesso processada pela API
     * registers: Retorno da coleção de dados solicitados a API
     */
    errors: any[] = [];
    message: string;
    statusCode: number;
    registers: any[];

    constructor(private sharedLatestNewsService: SharedLatestNewsService) {}

    ngOnInit(): void {
        this.lastNews();
    }

    /**
     * lastNews() - Buscar últimas notícias publicadas
     */
    lastNews() {
        this.sharedLatestNewsService.getLatestNews(this.departmentType, this.page, this.perPage).subscribe(
            (returnSuccess) => {
                this.successCallbackApi(returnSuccess);
            },
            (returnFail) => {
                this.errorCallbackServer(returnFail);
            }
        );
    }

    /**
     * successCallbackApi: Retorna resultado da API
     * @param response
     */
    successCallbackApi(response: any) {
        this.message = response.description;
        this.statusCode = response.status_code;
        this.registers = response.registers;
        this.total = response.meta?.total;
    }

    /**
     * errorCallbackServer: Retorna resultado de erros do servidor
     * @param fail
     */
    errorCallbackServer(fail: any) {
        this.errors = fail.error.errors;
        this.statusCode = 1; // erro
        this.registers = null;
    }

    onPageChange(pageNumber) {
        this.page = pageNumber;
        this.lastNews();
    }
}
